import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Organization } from './page/organization'
import { OrganizationDelete } from './page/organization-delete'
import { ScheduledLanding } from './page/organization-scheduled'
import { SCHEDULED_PATH } from '../../../../shared/organization-deletion/organization-deletion'
import { useRoleOrgOrganization } from '../../../../role/hook/role-org'

// /org/organization: the organization's own page and its danger zone
// (delete organization, plan Task 26). The restore page is the restricted
// session's (restricted-shell.js); in an ordinary session its path only
// lands (ScheduledLanding).
export const LayoutOrganization = () => {
  const role = useRoleOrgOrganization()

  return (
    <Switch>
      {role.accessRead && <Route exact path="/org/organization" component={Organization} />}
      {role.accessRead && <Route exact path="/org/organization/delete" component={OrganizationDelete} />}
      <Route exact path={SCHEDULED_PATH} component={ScheduledLanding} />
    </Switch>
  )
}
